import {useTradeHeaderHook} from "../../../hooks/useTradeHeaderHook";
import {CFlex, DText, Flex} from "../../../styles/MarketStyles";
import {ColorText} from "../../../styles/CommonStyles";
import {formatNumber} from "../../../utils/common";
import {useMainContext} from "../../../contexts/main";
import Text from "../../../utils/Text";
import {TradeBox} from "../../../styles/BoxingStyles";


const RMarketDetails = () => {

    const { market } = useMainContext()
    const {
        price,
        currentChange,
        loading
    } = useTradeHeaderHook()


    return (
        <TradeBox>
            <CFlex fw style={{ padding: '10px 8px' }}>
                <Flex justify={'space-between'} fw style={{ direction: 'ltr' }}>
                    <ColorText tradeType={price.color} style={{ fontSize: '1.1rem' }}>
                        {formatNumber(price.tooman, { type: market?.pair })} {market?.pair?.toUpperCase()}
                    </ColorText>
                    {market.pair === 'irt' &&
                        <ColorText tradeType={price.color} style={{ fontSize: '0.8rem' }}>
                            {formatNumber(price.usdt, { type: 'usdt' })} USDT
                        </ColorText>
                    }
                </Flex>
                <CFlex fw>
                    <Flex fw justify={'space-between'} style={{ margin: '8px 0' }}>
                        <Flex width={'45%'} justify={'space-between'}>
                            <DText main cFontSize={'0.55rem'}>
                                <Text tid={'24change'} />
                            </DText>
                            <ColorText
                                type="number"
                                _type="number"
                                tradeType={
                                    currentChange?._24change > 0 ? "buy" : "sell"
                                }>
                                {formatNumber(currentChange?._24change, {point: 2})}%
                            </ColorText>
                        </Flex>
                        <Flex width={'45%'} justify={'space-between'}>
                            <DText main cFontSize={'0.55rem'}>
                                <Text tid={'7change'} />
                            </DText>
                            <ColorText
                                type="number"
                                _type="number"
                                tradeType={
                                    currentChange?._7change > 0 ? "buy" : "sell"
                                }
                            >
                                {formatNumber(currentChange?._7change, {point: 2})}%
                            </ColorText>
                        </Flex>
                    </Flex>
                    <Flex fw justify={'space-between'}>
                        <Flex width={'45%'} justify={'space-between'}>
                            <DText main cFontSize={'0.55rem'}>
                                <Text tid={'24high'} />
                            </DText>
                            <DText primary cFontSize={'0.55rem'}>
                                {formatNumber(currentChange?.max)} $
                            </DText>
                        </Flex>
                        <Flex width={'45%'} justify={'space-between'}>
                            <DText main cFontSize={'0.55rem'}>
                                <Text tid={'24low'} />
                            </DText>
                            <DText primary cFontSize={'0.55rem'}>
                                {formatNumber(currentChange?.min)} $
                            </DText>
                        </Flex>
                    </Flex>
                </CFlex>
            </CFlex>
        </TradeBox>

    )
}

export default RMarketDetails
